import React from 'react';
// import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Modal from "../../../../myfin_v2/elements/Modal";
import buttoncss from "../../../../myfin_v2/css/button.module.css";
import commoncss from "../../../../myfin_v2/css/common.module.css";
import InputGroup from "../../../../myfin_v2/elements/InputGroup";
import { Button } from "../../../../myfin_v2/elements/Button";
import { ReactComponent as CloseIcon } from "../../../../myfin_v2/assets/icons/close.svg";

export default function ReturnDataRegisterLogModal({
    setReturnLogModal,
    returnLogModal,
    OnClick
}) {

    const handleClose = () => {
        setReturnLogModal(prev => ({...prev, isOpen: false, returnText: "", registerId: "", title:"" }))
    };

    return (
        <Modal
            title="Reason"
            bodycss={commoncss.unsetPadding}
            headerActions={
                <CloseIcon
                onClick={handleClose}
                className="clickable"
                />
            }
            footerActions={
                <>
                    <Button
                        btnColor={buttoncss.secondary}
                        onClick={handleClose}
                        label="Cancel"
                    />
                    <Button
                        btnColor={buttoncss.primary}
                        label="Return"
                        onClick={OnClick}
                    />
                </>
            }
            >
            <div className={commoncss.pd1530}>
                <InputGroup
                    label="Reason"
                    inputs={[
                    <>
                        <textarea
                            placeholder='Enter reason....'
                            onChange={(e)=> {
                                setReturnLogModal(prev => ({...prev, returnText: e.target.value }))
                            }}
                        />
                    </>,
                    ]}
                />
                </div>
            </Modal>
    )

    // return (
    //     <React.Fragment>
    //         <Dialog
    //             open={returnLogModal.isOpen}
    //             onClose={handleClose}
    //         >
    //             <DialogTitle minWidth={420} >Reason</DialogTitle>
    //             <DialogContent>
    //                 {/* <DialogContentText minWidth={420} className='text-capitalize'>
    //                     {returnLogModal.title}
    //                 </DialogContentText> */}
    //                 <div className='d-flex flex-column mt-2' >
    //                     {/* <label className='text-secondary'>Reason</label> */}
    //                     <textarea 
    //                         className='p-2 rounded shadow text-secondary font-size-14'
    //                         placeholder='Enter reason....'
    //                         onChange={(e)=> {
    //                             setReturnLogModal(prev => ({...prev, returnText: e.target.value }))
    //                         }}
    //                     />
    //                 </div>
    //             </DialogContent>
    //             <DialogActions>
    //                 <button className='bg-color-inherit px-3 py-1 rounded shadow text-danger border border-danger' onClick={handleClose}>Cancel</button>
    //                 <Button
    //                     className='bg-color-inherit px-3 py-1 rounded shadow text-info border border-info'
    //                     onClick={OnClick}
    //                 >
    //                     Return
    //                 </Button>
    //             </DialogActions>
    //         </Dialog>
    //     </React.Fragment>
    // );
}
